import { h } from 'hyperapp'
import Close  from './partials/close'
import Copy  from './partials/copy'

const Result = ({ clear, copy, regex, expressions }) => (
    <header class="result">
        <h2 class="result-expression">
            <span class="result-content">
                {expressions.length > 0 && <button type="button" class="result-copy" onclick={() => copy()}><Copy /></button>}
                <span>{expressions.length ? `${regex.toRegExp()}` : 'Use the buttons bellow to start building your regular expression.'}</span>
                {expressions.length > 0 && <button type="button" class="result-clear" onclick={() => clear()}><Close /></button>}
            </span>
        </h2>
    </header>
)

export default Result



// WEBPACK FOOTER //
// ./src/scripts/components/result.js